@switch (mode()) {
  @case ('thumbnail') {
    <i class="fa fa-sitemap"></i>
  }
  @case ('view') {
    <i class="fa fa-sitemap"></i>
  }
  @case ('details') {
    <pre>{{ asset().storagePath }}</pre>
    <dl>
      <div class="row">
        <dt>Description:</dt>
        <dd>{{ asset().description }}</dd>
      </div>
    </dl>
  }
}
